module.exports = __webpack_public_path__ + "img/inserma_login.0f02aa38.png";